var _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHydrogenUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 779,
    height: 270,
    viewBox: "0 0 779 270",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.199 157.2V62C157.199 45.2 179.599 6 200.69 6H398.135C419.464 6 438.33 18.5214 455.46 29.8906C469.703 39.3436 482.745 48 495.006 48H731.199C773.199 48 773.199 87.2 773.199 87.2V157.2V263.6H157.199V157.2Z",
    fill: "#8AE0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M455.46 29.8906L458.557 25.2247L458.557 25.2247L455.46 29.8906ZM773.199 263.6V269.2H778.799V263.6H773.199ZM157.199 263.6H151.599V269.2H157.199V263.6ZM151.599 62V157.2H162.799V62H151.599ZM200.69 0.4C193.694 0.4 187.149 3.62167 181.56 7.96603C175.918 12.3516 170.767 18.2476 166.431 24.513C162.081 30.7984 158.422 37.6404 155.834 44.0719C153.29 50.3937 151.599 56.7641 151.599 62H162.799C162.799 58.8359 163.909 54.0063 166.224 48.2531C168.495 42.6096 171.754 36.5016 175.64 30.887C179.54 25.2524 183.944 20.2984 188.433 16.809C192.976 13.2783 197.14 11.6 200.69 11.6V0.4ZM398.135 0.4H200.69V11.6H398.135V0.4ZM458.557 25.2247C441.749 14.0696 421.452 0.4 398.135 0.4V11.6C417.477 11.6 434.911 22.9732 452.363 34.5564L458.557 25.2247ZM495.006 42.4C490.152 42.4 484.752 40.6731 478.516 37.4994C472.286 34.3286 465.747 29.9969 458.557 25.2247L452.363 34.5564C459.416 39.2372 466.519 43.9603 473.436 47.4809C480.347 50.9987 487.598 53.6 495.006 53.6V42.4ZM731.199 42.4H495.006V53.6H731.199V42.4ZM773.199 87.2C778.799 87.2 778.799 87.1969 778.799 87.1937C778.799 87.1924 778.799 87.189 778.799 87.1864C778.799 87.1813 778.799 87.1756 778.799 87.1692C778.799 87.1566 778.799 87.1414 778.799 87.124C778.799 87.089 778.798 87.0445 778.797 86.9908C778.795 86.8834 778.792 86.7389 778.785 86.5599C778.773 86.202 778.748 85.7049 778.701 85.0883C778.607 83.857 778.421 82.1376 778.056 80.0906C777.329 76.0211 775.866 70.5188 772.886 64.9556C769.89 59.363 765.329 53.6575 758.439 49.3703C751.532 45.0725 742.603 42.4 731.199 42.4V53.6C740.795 53.6 747.617 55.8275 752.522 58.8797C757.444 61.9425 760.759 66.037 763.013 70.2444C765.283 74.4812 766.444 78.7789 767.03 82.0594C767.321 83.6874 767.464 85.0305 767.534 85.9429C767.568 86.3982 767.585 86.7433 767.593 86.9596C767.596 87.0677 767.598 87.1434 767.599 87.1843C767.599 87.2048 767.599 87.2165 767.599 87.2192C767.599 87.2206 767.599 87.2197 767.599 87.2165C767.599 87.2149 767.599 87.2127 767.599 87.21C767.599 87.2086 767.599 87.2061 767.599 87.2054C767.599 87.2028 767.599 87.2 773.199 87.2ZM778.799 157.2V87.2H767.599V157.2H778.799ZM767.599 157.2V263.6H778.799V157.2H767.599ZM773.199 258H157.199V269.2H773.199V258ZM162.799 263.6V157.2H151.599V263.6H162.799Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 62V157.2H622V87.2C622 87.2 622 48 580 48H343.806C316.8 48 286 6 246.935 6H49.4903C28.4 6 6 45.2 6 62Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 11.2,
    strokeLinecap: "square"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 157.199,
    width: 616,
    height: 106.4,
    fill: "black",
    stroke: "black",
    strokeWidth: 11.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 90,
    width: 106.4,
    height: 84,
    rx: 11.2,
    fill: "#8AE0FF",
    stroke: "black",
    strokeWidth: 5.6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 28.3984,
    y: 90,
    width: 106.4,
    height: 84,
    rx: 11.2,
    fill: "#8AE0FF",
    stroke: "black",
    strokeWidth: 5.6
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 263.602,
    y: 90,
    width: 106.4,
    height: 84,
    rx: 11.2,
    fill: "#8AE0FF",
    stroke: "black",
    strokeWidth: 5.6
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 381.199,
    y: 90,
    width: 106.4,
    height: 84,
    rx: 11.2,
    fill: "#8AE0FF",
    stroke: "black",
    strokeWidth: 5.6
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 498.801,
    y: 90,
    width: 106.4,
    height: 84,
    rx: 11.2,
    fill: "#8AE0FF",
    stroke: "black",
    strokeWidth: 5.6
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 647.198,
    y: 92.8,
    width: 100.8,
    height: 78.4,
    rx: 8.4,
    fill: "#8AE0FF",
    stroke: "black",
    strokeWidth: 5.6
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 647.198,
    y: 64.8,
    width: 100.8,
    height: 11.2,
    rx: 5.6,
    fill: "black",
    stroke: "black",
    strokeWidth: 5.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M644.398 199.895C644.398 192.5 651.438 187.135 658.568 189.096L687.741 197.118C688.708 197.384 689.707 197.519 690.71 197.519H709.88C711.019 197.519 712.151 197.345 713.238 197.004L736.24 189.775C743.456 187.507 750.798 192.896 750.798 200.459V235.599C750.798 241.785 745.784 246.799 739.598 246.799H655.598C649.413 246.799 644.398 241.785 644.398 235.599V199.895Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 5.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHydrogenUp);
export default __webpack_public_path__ + "static/media/hydrogen-up.37d0338010bffee622e3307455ad8dc5.svg";
export { ForwardRef as ReactComponent };